import { useCallback } from 'react';
import { LOCATION } from '../../../../../bi/mixpanel/constants';

const useMarketplaceTagsDropdownHandlers = ({ setBriefData }) => {
    const handleClear = useCallback(() => {
        setBriefData({ keywords: [] }, { location: LOCATION.STICKY });
    }, [setBriefData]);

    const handleApply = useCallback(
        (tags) => {
            setBriefData({ keywords: tags }, { location: LOCATION.STICKY });
        },
        [setBriefData]
    );

    return {
        handleClear,
        handleApply,
    };
};

export default useMarketplaceTagsDropdownHandlers;
